Namespace 'Monitoring.Views.SocialContents.Filters'

class Monitoring.Views.SocialContents.Filters.AppliedDiscoveredTopicsFilterView extends Backbone.View

  template: JST["backbone/templates/monitoring/filters/vue/common_template"]

  initialize: (@options = {}) ->
    @searchQuery = @options.searchQuery

    @vueAppliedFilter = new VueInBackbone.VueComponent(
      'discovered-topics-applied-filter',
      {
        searchQuery: @searchQuery.toJSON()
      }
    )

  render: ->
    @$el.html(@template)
    @$el.find('.filters-vue-common-template').html(@vueAppliedFilter.el)
    @vueAppliedFilter.render()
    @vueAppliedFilter.on('clean', @cleanFilter)
    @vueAppliedFilter.on('remove-value', @removeFilterValue)

    @

  cleanFilter: =>
    @searchQuery.resetField('discovered_topics_ids')
    @searchQuery.resetField('related_discovered_topics_ids')
    @triggerSearchQueryChanged()

  removeFilterValue: ({id, value}) =>
    @searchQuery.removeValueFromField(id, value)
    @triggerSearchQueryChanged()

  triggerSearchQueryChanged: =>
    @eventAggregator.trigger('searchQueryChanged', @searchQuery)

  destroy: ->
    @vueAppliedFilter.remove()
    @remove()
